/**
 * Discovery 문구 — 앱 `locales/en/explore.json` · `common.json` 의 해당 키를 그대로 옮겼다.
 * @description 웹은 아직 영어 한 벌이라 i18n 계층 없이 상수로 둔다. 키 이름을 앱과 같게
 *   두어 나중에 `t()` 로 갈아끼울 때 자리가 맞는다.
 */
export const EXPLORE_COPY = {
  title: "Explore",
  spotlightCollabs: "Collab Spotlights",
  postSpotlights: { title: "Post Spotlights" },
  fanbases: {
    title: "Fanbases you might know",
    memberCount: (count: number) =>
      `${count.toLocaleString()} member${count === 1 ? "" : "s"}`,
  },
  suggestedCollabs: {
    daysLeft: (days: number) => `${days}d left`,
    state: {
      forming: "Forming",
      submitted: "Submitted",
      wrapping: "Wrapping up",
      completed: "Completed",
    },
  },
  banner: { label: "Banner" },
} as const;

/** 앱 `common.json` */
export const COMMON_COPY = {
  button: { seeAll: "See All", retry: "Retry", loadMore: "Load more" },
  error: { generic: "Something went wrong", notFound: "Nothing here yet" },
} as const;
